import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-export-dataset-progress',
  imports: [SharedUtilToastModule],
  templateUrl: './export-dataset-progress.component.html',
  styleUrls: ['./export-dataset-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ExportDatasetProgressComponent extends Toast {}
